import { ReactComponent as OutlineCopy16 } from "assets/svg/outline-copy-16.svg";
import { ReactComponent as OutlineCopy } from "assets/svg/outline-copy.svg";
import { ReactComponent as OutlineCopyNew } from "assets/svg/outline-copy-new.svg";
import SuccessTag from "components/success-tag/SuccessTag";
import { useMemo, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import styles from "./CopyToClipboardButton.module.scss";

interface CopyToClipboardButtonProps {
  onClick: () => void;
  size?: "regular" | "small" | "new";
}

const CopyToClipboardButton = ({
  onClick,
  size = "regular",
}: CopyToClipboardButtonProps) => {
  const copyToClipboardButtonRef = useRef<HTMLButtonElement>(null);

  const [isShowingSuccessTag, setIsShowingSuccessTag] = useState(false);

  const icon = useMemo(() => {
    switch (size) {
      case "regular":
        return <OutlineCopy />;
      case "small":
        return <OutlineCopy16 />;
      case "new":
        return <OutlineCopyNew />;
    }
  }, [size]);

  return (
    <Button
      ref={copyToClipboardButtonRef}
      className={styles[size]}
      onClick={() => {
        onClick();
        setIsShowingSuccessTag(true);
      }}
      variant="light"
      title="Copy to clipboard"
    >
      {icon}

      <SuccessTag
        show={isShowingSuccessTag}
        successMsg={"Copied to clipboard"}
        duration={2000}
        onHide={() => setIsShowingSuccessTag(false)}
        placement={size === "small" ? "left" : "top"}
        target={copyToClipboardButtonRef.current}
      />
    </Button>
  );
};

export default CopyToClipboardButton;
